// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --nav-height: 38vh;
}

a {
  text-decoration: none;
  color: inherit;
}

.css-b3pver-MuiButtonBase-root-MuiAccordionSummary-root {
  background-color: #000000 !important;
}

.css-iyqxx-MuiPaper-root-MuiDrawer-paper {
  background-color: unset !important;
}

.css-m58w3v-MuiButtonGroup-root .MuiButtonGroup-grouped:not(:last-of-type) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: 1px solid #bdbdbd;
  border-color: rgb(255, 255, 255) !important;
}

.css-1d2x4iq-MuiButtonGroup-root .MuiButtonGroup-grouped:not(:last-of-type) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: 1px solid #bdbdbd;
  border-color: rgb(44, 44, 56) !important;
}

.displayBlog {
  display: none !important;
}

.MuiStack-root.pl-3.css-4uxnca-MuiStack-root {
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
  height: 87vh !important;
  overflow-y: none !important;
  overflow-x: none !important;
}

.css-rgzzrd-MuiStack-root {
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
  height: 87vh !important;
  overflow-y: none !important;
  overflow-x: none !important;
}

.MuiStack-root.css-wpt0xj-MuiStack-root {
  margin-bottom: unset !important;
  gap: 14px !important;
}

.blog-list {
  --nav-height: 63vh !important; /* Override nav bar height for blog-list page */
}

.MuiStack-root.css-iazx4v-MuiStack-root {
  margin-bottom: 0px !important;
  max-height: unset !important;
  height: var(--nav-height) !important;
  gap: 0px !important;
  margin-top: -22px !important;
}

.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiAccordion-root.MuiAccordion-rounded.MuiAccordion-gutters.css-1u6s56s-MuiPaper-root-MuiAccordion-root {
  background: transparent !important;
}

.activitiesMenu {
  margin-left: 25px;
}

.activitiesMenu {
  cursor: pointer;
}

@media only screen and (max-width: 600px) {
  .displayBlog {
    display: block !important;
  }
}
@media only screen and (min-width: 601x) {
  .displayBlog {
    display: none !important;
  }
}
.css-1e7veia-MuiFormLabel-root-MuiInputLabel-root {
  top: -9px !important;
}

.css-qkzy0d-MuiFormLabel-root-MuiInputLabel-root {
  font-size: 0.9rem !important;
}

.b-color {
  border: none !important;
}

.css-1mzs5c6-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded {
  min-height: 45px !important;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/components/layout/side-navigaion/side-navigation.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AACA;EACE,qBAAA;EACA,cAAA;AAEF;;AAAA;EACE,oCAAA;AAGF;;AAAA;EACE,kCAAA;AAGF;;AAAA;EACE,0BAAA;EAEA,6BAAA;EAEA,+BAAA;EAEA,2CAAA;AAAF;;AAGA;EACE,0BAAA;EAEA,6BAAA;EAEA,+BAAA;EAEA,wCAAA;AAHF;;AAMA;EACE,wBAAA;AAHF;;AAMA;EACE,wBAAA;EAEA,iCAAA;EAEA,yCAAA;EAEA,uBAAA;EAEA,2BAAA;EAEA,2BAAA;AARF;;AAUA;EACE,wBAAA;EAEA,iCAAA;EAEA,yCAAA;EAEA,uBAAA;EAEA,2BAAA;EAEA,2BAAA;AAZF;;AAeA;EACE,+BAAA;EAEA,oBAAA;AAbF;;AAgBA;EACE,6BAAA,EAAA,+CAAA;AAbF;;AAgBA;EACE,6BAAA;EAEA,4BAAA;EAEA,oCAAA;EAEA,mBAAA;EACA,4BAAA;AAhBF;;AAmBA;EACE,kCAAA;AAhBF;;AAmBA;EACE,iBAAA;AAhBF;;AAkBA;EACE,eAAA;AAfF;;AAkBA;EACE;IACE,yBAAA;EAfF;AACF;AAkBA;EACE;IACE,wBAAA;EAhBF;AACF;AAkBA;EACE,oBAAA;AAhBF;;AAkBA;EACE,4BAAA;AAfF;;AAiBA;EACE,uBAAA;AAdF;;AAiBA;EACE,2BAAA;AAdF","sourcesContent":[":root {\n  --nav-height: 38vh;\n}\na {\n  text-decoration: none;\n  color: inherit;\n}\n.css-b3pver-MuiButtonBase-root-MuiAccordionSummary-root {\n  background-color: #000000 !important;\n}\n\n.css-iyqxx-MuiPaper-root-MuiDrawer-paper {\n  background-color: unset !important;\n}\n\n.css-m58w3v-MuiButtonGroup-root .MuiButtonGroup-grouped:not(:last-of-type) {\n  border-top-right-radius: 0;\n\n  border-bottom-right-radius: 0;\n\n  border-right: 1px solid #bdbdbd;\n\n  border-color: rgb(255 255 255) !important;\n}\n\n.css-1d2x4iq-MuiButtonGroup-root .MuiButtonGroup-grouped:not(:last-of-type) {\n  border-top-right-radius: 0;\n\n  border-bottom-right-radius: 0;\n\n  border-right: 1px solid #bdbdbd;\n\n  border-color: rgb(44 44 56) !important;\n}\n\n.displayBlog {\n  display: none !important;\n}\n\n.MuiStack-root.pl-3.css-4uxnca-MuiStack-root {\n  display: flex !important;\n\n  flex-direction: column !important;\n\n  justify-content: space-between !important;\n\n  height: 87vh !important;\n\n  overflow-y: none !important;\n\n  overflow-x: none !important;\n}\n.css-rgzzrd-MuiStack-root {\n  display: flex !important;\n\n  flex-direction: column !important;\n\n  justify-content: space-between !important;\n\n  height: 87vh !important;\n\n  overflow-y: none !important;\n\n  overflow-x: none !important;\n}\n\n.MuiStack-root.css-wpt0xj-MuiStack-root {\n  margin-bottom: unset !important;\n\n  gap: 14px !important;\n}\n\n.blog-list {\n  --nav-height: 63vh !important; /* Override nav bar height for blog-list page */\n}\n\n.MuiStack-root.css-iazx4v-MuiStack-root {\n  margin-bottom: 0px !important;\n\n  max-height: unset !important;\n\n  height: var(--nav-height) !important;\n\n  gap: 0px !important;\n  margin-top: -22px !important;\n}\n\n.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiAccordion-root.MuiAccordion-rounded.MuiAccordion-gutters.css-1u6s56s-MuiPaper-root-MuiAccordion-root {\n  background: transparent !important;\n}\n\n.activitiesMenu {\n  margin-left: 25px;\n}\n.activitiesMenu {\n  cursor: pointer;\n}\n\n@media only screen and (max-width: 600px) {\n  .displayBlog {\n    display: block !important;\n  }\n}\n\n@media only screen and (min-width: 601x) {\n  .displayBlog {\n    display: none !important;\n  }\n}\n.css-1e7veia-MuiFormLabel-root-MuiInputLabel-root {\n  top: -9px !important;\n}\n.css-qkzy0d-MuiFormLabel-root-MuiInputLabel-root {\n  font-size: 0.9rem !important;\n}\n.b-color {\n  border: none !important;\n}\n\n.css-1mzs5c6-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded {\n  min-height: 45px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
